import {
  MEDIA_SIZE_160,
  MEDIA_SIZE_240,
  MEDIA_SIZE_320,
  MEDIA_SIZE_480,
  MEDIA_SIZE_640,
  MEDIA_SIZE_960,
  MEDIA_SIZE_1200,
  MEDIA_SIZE_1920,
} from '../constants/sizes';

export enum VideoSubFormat {
  Fset160 = 72,
  Fset240 = 88,
  Fset320 = 73,
  Fset480 = 74,
  Fset640 = 76,
  Fset960 = 75,
  Fset1200 = 86,
  Fset1920 = 77,
}

/** @deprecated use VideoSubFormat.Fset160  */
export const VIDEO_SUB_FORMAT_FSET_160 = VideoSubFormat.Fset160;
/** @deprecated use VideoSubFormat.Fset240  */
export const VIDEO_SUB_FORMAT_FSET_240 = VideoSubFormat.Fset240;
/** @deprecated use VideoSubFormat.Fset320  */
export const VIDEO_SUB_FORMAT_FSET_320 = VideoSubFormat.Fset320;
/** @deprecated use VideoSubFormat.Fset480  */
export const VIDEO_SUB_FORMAT_FSET_480 = VideoSubFormat.Fset480;
/** @deprecated use VideoSubFormat.Fset640  */
export const VIDEO_SUB_FORMAT_FSET_640 = VideoSubFormat.Fset640;
/** @deprecated use VideoSubFormat.Fset960  */
export const VIDEO_SUB_FORMAT_FSET_960 = VideoSubFormat.Fset960;
/** @deprecated use VideoSubFormat.Fset1200  */
export const VIDEO_SUB_FORMAT_FSET_1200 = VideoSubFormat.Fset1200;
/** @deprecated use VideoSubFormat.Fset1920  */
export const VIDEO_SUB_FORMAT_FSET_1920 = VideoSubFormat.Fset1920;

export const VIDEO_SUB_FORMAT_FSET_BY_SIZE: Record<number, VideoSubFormat> = {
  [MEDIA_SIZE_160]: VideoSubFormat.Fset160,
  [MEDIA_SIZE_240]: VideoSubFormat.Fset240,
  [MEDIA_SIZE_320]: VideoSubFormat.Fset320,
  [MEDIA_SIZE_480]: VideoSubFormat.Fset480,
  [MEDIA_SIZE_640]: VideoSubFormat.Fset640,
  [MEDIA_SIZE_960]: VideoSubFormat.Fset960,
  [MEDIA_SIZE_1200]: VideoSubFormat.Fset1200,
  [MEDIA_SIZE_1920]: VideoSubFormat.Fset1920,
};

export enum ImageSubFormat {
  Full = 64,
  F160 = 79,
  F240 = 89,
  F320 = 80,
  F480 = 81,
  F640 = 82,
  F960 = 83,
  F1200 = 87,
  F1920 = 85,
}

/** @deprecated use ImageSubFormat.Full  */
export const IMAGE_SUB_FORMAT_FULL = ImageSubFormat.Full;
/** @deprecated use ImageSubFormat.F160  */
export const IMAGE_SUB_FORMAT_160 = ImageSubFormat.F160;
/** @deprecated use ImageSubFormat.F240  */
export const IMAGE_SUB_FORMAT_240 = ImageSubFormat.F240;
/** @deprecated use ImageSubFormat.F320  */
export const IMAGE_SUB_FORMAT_320 = ImageSubFormat.F320;
/** @deprecated use ImageSubFormat.F480  */
export const IMAGE_SUB_FORMAT_480 = ImageSubFormat.F480;
/** @deprecated use ImageSubFormat.F640  */
export const IMAGE_SUB_FORMAT_640 = ImageSubFormat.F640;
/** @deprecated use ImageSubFormat.F960  */
export const IMAGE_SUB_FORMAT_960 = ImageSubFormat.F960;
/** @deprecated use ImageSubFormat.F1200  */
export const IMAGE_SUB_FORMAT_1200 = ImageSubFormat.F1200;
/** @deprecated use ImageSubFormat.F1920  */
export const IMAGE_SUB_FORMAT_1920 = ImageSubFormat.F1920;

export const IMAGE_SUB_FORMAT_BY_SIZE: Record<number, ImageSubFormat> = {
  [MEDIA_SIZE_160]: ImageSubFormat.F160,
  [MEDIA_SIZE_240]: ImageSubFormat.F240,
  [MEDIA_SIZE_320]: ImageSubFormat.F320,
  [MEDIA_SIZE_480]: ImageSubFormat.F480,
  [MEDIA_SIZE_640]: ImageSubFormat.F640,
  [MEDIA_SIZE_960]: ImageSubFormat.F960,
  [MEDIA_SIZE_1200]: ImageSubFormat.F1200,
  [MEDIA_SIZE_1920]: ImageSubFormat.F1920,
};

export const SIMPLE_REPORT_COLOR = 37;
export const POLISH_ANGLES_REPORT_BOTH_ANGLES = 40;
export const PLOT_ACTUAL_BOTH_AXIS_ASYM = 43;
export const PLOT_BOTH_AXES_SYM_COR = 46;
export const DIAMETER_REPORT_COLOR = 49;

export const AVAILABLE_POLISHES = [
  POLISH_ANGLES_REPORT_BOTH_ANGLES,
  PLOT_ACTUAL_BOTH_AXIS_ASYM,
  SIMPLE_REPORT_COLOR,
  DIAMETER_REPORT_COLOR,
  PLOT_BOTH_AXES_SYM_COR,
];
export const POLISHES_SORTING = [
  SIMPLE_REPORT_COLOR,
  POLISH_ANGLES_REPORT_BOTH_ANGLES,
  PLOT_ACTUAL_BOTH_AXIS_ASYM,
  PLOT_BOTH_AXES_SYM_COR,
  DIAMETER_REPORT_COLOR,
];

export type MediaSubFormatId = VideoSubFormat | ImageSubFormat;

export class MediaSubFormatModel {
  id!: MediaSubFormatId;
  r!: number;
}

export default class MediaSubFormat extends MediaSubFormatModel {
  constructor(model: MediaSubFormatModel) {
    super();

    this.id = model.id;
    this.r = model.r;
  }

  isFsetSubFormat() {
    return [
      VideoSubFormat.Fset160,
      VideoSubFormat.Fset240,
      VideoSubFormat.Fset320,
      VideoSubFormat.Fset480,
      VideoSubFormat.Fset640,
      VideoSubFormat.Fset960,
      VideoSubFormat.Fset1200,
      VideoSubFormat.Fset1920,
    ].includes(this.id as VideoSubFormat);
  }

  isImageSubFormat() {
    return [
      ImageSubFormat.Full,
      ImageSubFormat.F160,
      ImageSubFormat.F240,
      ImageSubFormat.F320,
      ImageSubFormat.F480,
      ImageSubFormat.F640,
      ImageSubFormat.F960,
      ImageSubFormat.F1200,
      ImageSubFormat.F1920,
    ].includes(this.id as ImageSubFormat);
  }
}
